import { capitalize } from 'lodash';
import { useMemo } from 'react';
import { ILocation } from 'types/location';
import { formatAddress } from 'utils';

export const useFilterData = (type: 'transaction' | 'appointment' = 'transaction', locations?: ILocation[]) => {
  const locationOptions =
    locations?.map((location) => ({
      label: `${location.name} - ${formatAddress(location.address)}`,
      value: location.id,
    })) || [];
  const withoutNotaryFilterBarOptions = useMemo(() => [{ label: 'Without Notary', value: true }], []);
  const ownerShipFilterBarOptions = useMemo(() => [{ label: `My ${capitalize(type)}s`, value: true }], []);

  return {
    withoutNotaryFilterBarOptions,
    ownerShipFilterBarOptions,
    locationFilterBarOptions: locationOptions,
  };
};
